import type { ReactNode } from 'react';
import type { Band } from '../layout/types';

type BandForeignObjectProps = {
  band: Band;
  children: ReactNode;
};

/**
 * Mounts HTML `children` inside the SVG canvas, scoped to a band's
 * dimensions. Callers render this inside a `<g transform="translate(band.x,
 * band.y)">` so the foreignObject itself always starts at (0, 0) in
 * band-local coordinates.
 */
export const BandForeignObject = ({
  band,
  children,
}: BandForeignObjectProps) => (
  <foreignObject
    x={0}
    y={0}
    width={band.width}
    height={band.height}
    style={{ overflow: 'visible' }}
  >
    {children}
  </foreignObject>
);
